import { getControlChannelRoots } from '@/component/companymanager/ChannelManager/services';
import { changeChannelType } from '@/component/login/action';
import store from '@/store';
import { throttle } from "lodash";
import { Utils } from "../../../tools/utils";
import { getCorrectRegulations } from "./../../system/api/salesQualification";


/**
 * 销售资质权限
 */
const getAgentQualificationPermission = async () => {
    try {
        const result = await getCorrectRegulations(Utils.getOrgId());
        const { enableSaleCompliance } = result.data;
        return enableSaleCompliance === 1; // 1 开通 0 未开通
    } catch (e) {
        return false;
    }

}
// 渠道管理权限控制
const getOrgIsOpenChannel = async () => {
  const userData = Utils.getUserData();
  const channelStatus = store.getState().isOpenChannel
  return channelStatus && userData.companyLevelId === '10005'
}
const permissions = {
    // 系统管理 - 销售资质
    '/system/salesQualification': getAgentQualificationPermission,
    // 组织机构 —— 渠道管理
    '/company/channelManager': getOrgIsOpenChannel
}

const forEach = async (arr, fn) => {
    for (let i = 0; i < arr.length; i++) {
        const item = arr[i];
        await fn(item, i, arr);
    }
}

const getControlChannel = throttle(async()=>{
    const res = await getControlChannelRoots()
    const channelStatus = res.status === 200 && res.data
    store.dispatch(changeChannelType(channelStatus));
},100)

export const checkMenuPermission = async (list) => {
    const temp = [];
    try{
        getControlChannel()
    }finally {
      await forEach(list, async (menuItem) => {
          if (menuItem.path && permissions[menuItem.path]) {
              const flag = await permissions[menuItem.path]();
              if (!flag) return;
          }
          if (menuItem.children && menuItem.children.length) {
              menuItem.children = await checkMenuPermission(menuItem.children)
          }
          temp.push(menuItem);
      })
      return temp;
    }
}
//获取用户功能数据权限
export const getUserPermissionInfo  = async (data) => {
    return await doGetRequest({
        url: '/api/admin/merchantPlatform/user/getUserPermissionInfo',
        params: data
    });
}
